import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@applyboard/ui-components';
import { SidebarNotAvailableStyled, SidebarTable } from "./styles";
var randomId = function randomId() {
  return Math.random().toString(36).substring(7);
};
var Table = function Table(_ref) {
  var _ref$info = _ref.info,
    info = _ref$info === void 0 ? [] : _ref$info,
    _ref$extraInfo = _ref.extraInfo,
    extraInfo = _ref$extraInfo === void 0 ? false : _ref$extraInfo,
    _ref$keyPrefix = _ref.keyPrefix,
    keyPrefix = _ref$keyPrefix === void 0 ? randomId() : _ref$keyPrefix;
  return /*#__PURE__*/React.createElement(SidebarTable, {
    extraInfo: extraInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-body"
  }, info === null || info === void 0 ? void 0 : info.map(function (_ref2, idx) {
    var name = _ref2.name,
      value = _ref2.value;
    return /*#__PURE__*/React.createElement("div", {
      className: "table-row",
      key: "".concat(keyPrefix, "-").concat(name, "-").concat(idx),
      "data-cy": "sidebar-content-".concat(name.replace(/\s+/g, '-').replace('/', '').toLowerCase())
    }, /*#__PURE__*/React.createElement("div", {
      className: "table-data"
    }, /*#__PURE__*/React.createElement(Box, {
      component: "span"
    }, name)), /*#__PURE__*/React.createElement("div", {
      className: "table-data"
    }, value != null && value !== '' ? value : /*#__PURE__*/React.createElement(SidebarNotAvailableStyled, null, "N/A")));
  })));
};
Table.propTypes = {
  info: PropTypes.array,
  extraInfo: PropTypes.bool,
  keyPrefix: PropTypes.string
};
export default Table;